import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Logs from "../Logs/Logs";
import { updateClassMarkingStudentGranularSteps } from "../../../../../../store/actions/class-marking.actions";
import useMarking from "../../../../../../hooks/maestro/useMarking";

const LogsInfo = () => {
  const { onModeMarking } = useMarking();
  const ulData = useSelector((state) => state?.class?.unitOfLearning || {});

  const student = useSelector((state) => state?.classMarking?.student);
  const studentLoading = useSelector(
    (state) => state?.classMarking?.studentLoading
  );
  const mode = useSelector((state) => state?.classMarking?.mode || []);
  const currentMode = mode?.find((item) => item.studentId === student?._id);

  const lcsIds = useSelector((state) => state?.classMarking.lcsIds || []);

  const completed = useSelector((state) => state?.classMarking?.completedType);
  const dispatch = useDispatch();

  const logs =
    completed === "completedTeacher"
      ? student?.logMarkingTeacher || []
      : completed === "completedStudent"
      ? student?.logMarkingStudent || []
      : [];

  const onRemove = (logId) => {
    if (!logId) return;
    const find = logs
    .map((log) => ({
      _id: String(log._id || log.id),
      ...log,
    }))
    .find((item) => item._id === logId);

    if (find) {
      const lc = student.lcs.find((lc) => String(lc._id) === String(find.lcId));
      if (lc) {
        const { from, lcId } = find;
        const granularSteps = lc.granularSteps.map((gs) => {
          const gsf = from.find((f) => f.id === gs.id);
          if (gsf) {
            return {
              ...gs,
              [completed]: gsf.completed,
            };
          }
          return gs;
        });
        const logMarking = [...logs]
          .map((log) => ({
            _id: String(log._id || log.id),
            ...log,
          }))
          .filter((item) => item._id !== logId);
        dispatch(
          updateClassMarkingStudentGranularSteps(
            lcId,
            completed,
            granularSteps,
            [...logMarking]
          )
        );
        onModeMarking(student, logMarking);
      }
    }
  };

  const permission = useSelector(
    (state) => state?.session?.permissions?.["marking-class"] || {}
  );

  const checkPermission = () => {
    if (completed === "completedTeacher" && permission?.["by-teacher"]) {
      return true;
    }
    if (completed === "completedStudent" && permission?.["by-student"]) {
      return true;
    }

    return false;
  };
  if (!student || !student?._id) return <></>;
  
  return (
    <Logs 
      logs={logs?.filter((lc) =>
        lcsIds?.length > 0 ? lcsIds?.includes(lc.lcId) : true
      ).map((log) => ({
        ...log,
        _id: String(log._id || log.id),
        ulId: student.lcs.find((lc) => String(lc._id) === String(log.lcId))?.ulId,
      } || []))} 
      isLoading={studentLoading}
      isLoadingSave={currentMode?.mode === "saving"}
      onRemove={ulData?.status === 'active' && checkPermission() ? onRemove : undefined}
    />
  );
};

export default LogsInfo;
